import { IConfig } from '@cian/config/shared';

import { TOfferType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

type TooltipText = { title: string; description: string };

const DEFAULT_TOOLTIP_TEXT: TooltipText = {
  title: 'Проверено в Росреестре',
  description:
    'в объявлении верно указаны площадь, этаж и другие ключевые параметры\n' +
    'объект находится по указанному адресу\n' +
    'объект можно законно продать или сдать — на него не наложен арест',
};

export function getRosReestrTooltipText(offerType: TOfferType, config: IConfig): TooltipText {
  if (offerType === 'commercial') {
    return {
      title: '',
      description: '',
    };
  }

  return config.get<TooltipText>('moderationRosReestrTooltip.Text') ?? DEFAULT_TOOLTIP_TEXT;
}
